export default {
      id: "growth-usage",
      viewBox: "0 0 8 6",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#growth-usage",
      toString: function () {
        return this.url;
      }
    }